module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAASlJREFUeNrs2c0NgjAUB/AmLsDVLRiJqzdHYANGYA5PjoAboBN49YY9lOSFIC3yPpP3T95FQ+lP24aWEDwej8fj8WxmiNUr6k+f+vTXhZMSzOG+aMCg9UESg35v2GBlFbFseGDAkI+ClhhTpbZZhnJDhIGIjmsSYmMgouFeUbAwoggsjArEGqa2ilhi3oUYlYg5dYLkMKoRpZj5e9WIHAZ+rh7xC1M67NRjzCKWq9mUntNMBv4jo5UJnpsjJpbc0lXLFKbJTGwTmNLHFNWYvU/BEHO1ihDZ1nLsR8TPzjC3u2IYigMIdgzVKQorpg30h3TkGImTxjv2vSTPftF+OMnlEW0+ang/chjTBT1vrCBmNaeNi8+xnrEuCiCPWK9Yn1i34PF4ducrwAAYnaWRlRyXBwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cross.png
// module id = 6qfX
// module chunks = 1